/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2025 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import * as React from "react";
import splashImg from "./splash.jpg?responsive";
import styled from "styled-components";
import podcastLogoImage from "podcast-logo-footer.svg";

const Container = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 512px;
  max-width: 90%;
  max-height: calc(100vh - 120px);
  overflow-y: auto;
  overflow-x: hidden;
  background: var(--spectrum-global-color-static-white);
  border-radius: 32px;
  box-shadow: var(--phonos-box-shadow-heavy);
`;

const Splash = styled.img.attrs({
  srcSet: splashImg.srcSet,
  alt: "",
})`
  aspect-ratio: ${splashImg.width / splashImg.height};
  width: 100%;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 32px 32px 32px;
  gap: 16px;
  line-height: 1.1;
`;

const Button = styled.button`
  background: transparent;
  border: none;
`;

const shuffle = (array: string[]): string[] => {
  return array.sort(() => Math.random() - 0.5);
};

export const FooterLogoModal: React.FC = () => {
  const mark = "Mark Webster";
  const team = [
    "Alex Hayton",
    "Ben Weitzman",
    "Emma Azelborn",
    "Harmony Jiroudek",
    "James Robert Somers",
    "Jay LeBoeuf",
    "Jonathan Pimento",
    "Sam Anderson",
    "Blake Sawyer",
    "Alexander Kramer",
    "Em Shotton",
    "Pietro Passarelli",
    "Scotty Jacobson",
    "Daniel Levenson",
    "Sam Mundle",
    "Scott Werner",
    "Cameron Cundiff",
  ];
  const productTeam = [mark].concat(shuffle(team));
  const specialThanks = shuffle(["Scott Belsky", "Matt Smith"]);
  const researchTeam = shuffle(["Zeyu Jin", "Jiaqi Su", "Gautham Mysore"]);
  return (
    <overlay-trigger>
      <Button slot="trigger">
        <img src={podcastLogoImage} alt={I18n.t("home.footer.logo_alt_text")} />
      </Button>
      <sp-overlay slot="click-content" type="modal">
        <Container>
          <Splash />
          <TextContainer>
            <div
              dangerouslySetInnerHTML={{
                __html: I18n.t("home.footer.copyright", {
                  currentYear: new Date().getFullYear(),
                }) as string,
              }}
            ></div>
            <div>Product Team: {I18n.toSentence(productTeam)}</div>
            <div>Research Team: {I18n.toSentence(researchTeam)}</div>
            <div>
              Special thanks to {I18n.toSentence(specialThanks)} for their
              support
            </div>
          </TextContainer>
        </Container>
      </sp-overlay>
    </overlay-trigger>
  );
};
